import React from 'react'
import { Color, Responsive, Size } from 'const'

import styled from 'styled-components'

const Banner = ({ title = 'お近くの店舗を検索の上、\nご予約ください。', buttonText = 'ご来店予約', onClick }) => {
  const makeReservationNow = () => {
    window.location.href = 'https://www.tanaka-megane.co.jp/store/'
  }

  return (
    <BannerBlock>
      <Title>{title}</Title>
      <Button onClick={makeReservationNow}>{buttonText}</Button>
    </BannerBlock>
  )
}

const BannerBlock = styled.div`
  background: ${Color.BACKGROUND.BANNER};
  padding: 60px 0px;
  text-align: center;
  @media screen and (max-width: ${Responsive.XS.DOWN}px) {
    padding-left: 6px;
    padding-right: 6px;
  }
`

const Title = styled.h5`
  font-size: ${Size.FONT.LG};
  font-weight: 700;
  color: inherit;
  @media screen and (max-width: ${Responsive.XS.DOWN}px) {
    white-space: pre-line;
  }
`

const Button = styled.button`
  background: ${Color.BUTTON.BANNER};
  color: ${Color.FONT.BUTTON_PRIMARY};
  border-radius: 50px;
  padding: 20px 0;
  border: none;
  width: 240px;
  margin-top: 20px;
  cursor: pointer;
  transition: background 0.3s ease;
  font-size: ${Size.FONT.BIG};
  font-weight: 700;
  font-family: inherit;

  &:hover {
    background: rgb(201, 44, 66);
  }
  @media screen and (max-width: ${Responsive.XS.DOWN}px) {
    padding-top: 15px;
    padding-bottom: 15px;
    width: 50vw;
  }
`

export default Banner
